module.exports = __webpack_public_path__ + "img/机组c.570a631a.svg";